export default "__VITE_ASSET__Cn9xHQyW__"